<template>
  <div
    class="sidebar-subtitle"
    @click="toggleSubMenu"
    :class="{ activeSubTab: activeSubTab, disabled: disabled }"
  >
    <div v-if="!item.show" class="management-submenu-item">
      {{ item.name }}
      <dev-tag
        v-if="item.dev"
        position="relative"
        :style="{ zoom: '80%', 'margin-left': '20px', 'font-weight': 300 }"
      />
    </div>
  </div>
</template>

<script>
import DevTag from "@/components/_Atoms/DevTag";

export default {
  components: { DevTag },

  props: ["item", "selected", "disabled"],

  computed: {
    activeSubTab() {
      if (this.selected && this.item) {
        return this.selected.name === this.item.name;
      }
      return false;
    }
  },

  methods: {
    toggleSubMenu() {
      this.$emit("toggle", this.item);
    }
  }
};
</script>

<style scoped>
.management-submenu-item {
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/Sidebar/SidebarSubmenuItem.vue